export default __webpack_public_path__ + "25bd83e5195df36b68902142282b67a9.svg";